export enum VacStatus {
  FULLY_PLUS = 'Fully +',
  FULLY = 'Fully',
  PARTIALLY = 'Partial',
  NO_VACCINE = 'No Vax',
}
